(function() {
  document.addEventListener('DOMContentLoaded', () => {
    let tabButtons  = document.querySelectorAll('[data-btn-id]'), 
        tabContents = document.querySelectorAll('.custom-stacked-image-with-text'), 
        index = 0; // listen to index changes

    if(tabButtons.length < 1) return

    // initiate first load
    if (window.matchMedia('(max-width: 768px)').matches) {
      const contentWrapper = tabButtons[index].nextElementSibling
      const nodeToDisplay = tabContents[index].childNodes[1]
      contentWrapper.innerHTML = nodeToDisplay.innerHTML
      contentWrapper.querySelector('.tab-buttons-targets').style.display = 'block'
    } else {
      tabContents[index].querySelector('.tab-buttons-targets__wrapper').style.display = 'block'
    }
  
    for (let i = 0; i < tabButtons.length; i++) {
      let el = tabButtons[i]
      el.addEventListener('click', e => tabButtonClickHandler(e, i))
    }
    
    /**
     * Button handlers
     * @param {Event} e 
     * @param {*} idx 
     * @returns 
     */
    function tabButtonClickHandler(e, idx) {
      e.preventDefault()

      if (index === idx) {
        console.log('same')
        return
      }

      tabButtons[index].classList.remove('tab-button--active')
      tabButtons[idx].classList.add('tab-button--active')

      if (window.matchMedia('(max-width: 768px)').matches) {
        tabButtons[index].nextElementSibling.innerHTML = "" // reset container
        tabButtons[index].parentElement.setAttribute('data-dropdown-state', false)
        
        tabContents[index].style.display = "none"
        tabContents[idx].style.display = "block"
        
        const contentWrapper = tabButtons[idx].nextElementSibling
        const nodeToDisplay = tabContents[idx].childNodes[1]
        tabButtons[idx].parentElement.setAttribute('data-dropdown-state', true)
  
        contentWrapper.innerHTML = nodeToDisplay.innerHTML
        contentWrapper.querySelector('.tab-buttons-targets').style.display = 'block'

      } else {
        tabContents[idx].querySelector('.tab-buttons-targets__wrapper').style.display = 'block'
        tabContents[index].querySelector('.tab-buttons-targets__wrapper').style.display = 'none'
      }

      index = idx // change prev index to current idx 
    } 
  })
})()

const booksy = document.querySelector(".booksy-widget-container");

if(booksy){
  const booking_btn = document.querySelector(".booking.button")
  booking_btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    booksy.querySelector(".booksy-widget-button").click()
  })
}

const booking_btns = document.querySelectorAll(".button[href='#booksy']");
if(booking_btns){
  Array.from(booking_btns).forEach((el) => {
    el.addEventListener('click',(e) => {
      e.preventDefault();
      e.stopPropagation();
      booksy.querySelector(".booksy-widget-button").click()
    })
  })
}

// manipulate insta app data
(() => {
  function feedIt(el, title, idx, caption) {
    const image = el.firstElementChild
    const src = image.getAttribute('data-instafeed-src')
    const alt = image.getAttribute('alt')

    const mod = idx % 2 ? 0 : 1
    let itemNum = 2
    if (mod == 0) itemNum = 1

    return `
      <div class="masonry__item masonry__item--${itemNum}">
        <img src="${src}" alt="${alt}" />
        <div class="masonry__content-wrapper">
          <div class="masonry__content">
            <p class="masonry__content-title">CAPTION</p>
            <p class="masonry__content-description">${caption}</p>
          </div>
          <a href="${title}" target="blank" class="masonry__content-url">
            <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.628362 8.9013C0.60795 7.51992 0.986106 6.15488 1.69085 4.87874C2.36122 3.66594 3.26149 2.62582 4.47008 1.85441C5.45737 1.224 6.53705 0.793849 7.71341 0.634458C10.0318 0.319765 12.1095 0.883761 13.9175 2.29477C14.373 2.65034 14.7619 3.08355 15.1809 3.48203C15.2819 3.57807 15.3818 3.67514 15.4763 3.77629C15.5516 3.857 15.6063 3.84577 15.6805 3.77016C15.992 3.45546 16.3089 3.14486 16.6259 2.83527C17.5111 1.96782 18.5575 1.34456 19.7607 0.953239C20.6341 0.670219 21.529 0.522068 22.4518 0.549655C23.539 0.583372 24.5746 0.827566 25.563 1.2618C26.8479 1.82682 27.8846 2.66873 28.7107 3.7579C29.6357 4.97785 30.2126 6.3296 30.4189 7.82031C30.4726 8.21061 30.5242 8.605 30.5209 8.99734C30.5113 10.5749 30.0977 12.0533 29.278 13.4296C28.8439 14.1581 28.3122 14.8182 27.6891 15.4026C26.8253 16.2118 25.9315 16.9924 25.0441 17.7781C24.3426 18.3993 23.6314 19.0113 22.9245 19.6275C22.0404 20.3978 21.1562 21.1703 20.2721 21.9407C19.4889 22.6222 18.7036 23.3016 17.9225 23.9841C17.2028 24.6125 16.4862 25.2429 15.7686 25.8723C15.7428 25.8958 15.7148 25.9172 15.6901 25.9407C15.616 26.0143 15.5462 26.0235 15.4624 25.9479C15.2776 25.7824 15.0864 25.623 14.8994 25.4595C13.7381 24.449 12.5779 23.4375 11.4165 22.427C10.5582 21.6791 9.69873 20.9332 8.84143 20.1843C7.71878 19.2024 6.6015 18.2154 5.47563 17.2376C4.66238 16.5316 3.84054 15.8338 3.10356 15.0521C1.91753 13.7923 1.13866 12.3384 0.795953 10.6761C0.678854 10.1131 0.612247 9.54601 0.628362 8.9013ZM15.5827 5.71145C15.5225 5.65934 15.5021 5.64402 15.4849 5.62562C14.9166 5.04528 14.3483 4.46494 13.7811 3.88459C12.6305 2.70755 11.2436 1.98315 9.53651 1.82682C8.44072 1.72669 7.3879 1.86565 6.3802 2.26106C5.1007 2.76273 4.09407 3.59442 3.32057 4.68359C2.16999 6.30201 1.74779 8.088 1.99058 10.017C2.17751 11.5047 2.81135 12.8156 3.8212 13.9599C4.49372 14.7221 5.27044 15.3852 6.04394 16.0514C7.12899 16.9842 8.2033 17.9283 9.2819 18.8673C10.6731 20.078 12.0644 21.2888 13.4567 22.4995C14.1012 23.0605 14.7437 23.6245 15.3915 24.1813C15.5934 24.355 15.5408 24.3744 15.7857 24.1629C16.6506 23.4171 17.5057 22.661 18.3662 21.911C19.2439 21.1458 20.1227 20.3835 21.0015 19.6193C21.8567 18.8755 22.7129 18.1316 23.568 17.3878C24.3372 16.7186 25.1054 16.0473 25.8767 15.3801C26.5847 14.7681 27.2454 14.1142 27.7933 13.3683C28.4346 12.4947 28.8439 11.5251 29.062 10.4799C29.2565 9.5501 29.2747 8.61726 29.1018 7.68646C28.8934 6.56153 28.454 5.52447 27.7449 4.5947C26.9607 3.56785 25.9874 2.76477 24.7422 2.27945C23.6389 1.84828 22.498 1.68582 21.312 1.86565C19.794 2.09554 18.5037 2.73719 17.4445 3.79774C16.8891 4.35459 16.3336 4.91143 15.7815 5.47134C15.7084 5.54491 15.6493 5.62971 15.5806 5.71247L15.5827 5.71145Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
      </div>
    `
  }

  document.addEventListener('DOMContentLoaded', () => {
    const poll = setInterval(() => {
      const feeds = document.querySelectorAll('.instafeed-new-layout-item')
      if (feeds.length > 0) {
        const title = document.querySelector('.instafeed-fullname')
        const captions = document.querySelectorAll('.instafeed-caption')
        console.log('title', title)
        console.log('feeds', feeds)
        const ignoreSrcs = ["https://scontent.cdninstagram.com/v/t51.29350-15/446220121_1236564777327648_4506616972748531020_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=18de74&_nc_ohc=3-rr45PFhCgQ7kNvgHM7sCi&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&_nc_gid=AXze4y91jTBkyUOJq6nwyD1&oh=00_AYC0A7Ni04L_TrWgpVpOoAeShssX7SY0XSKBTIlG_Sy64w&oe=67205512","https://scontent.cdninstagram.com/v/t51.29350-15/446335534_961675598942643_4698232335710503049_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=18de74&_nc_ohc=9QAgxbwcdtIQ7kNvgGTTcD0&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&_nc_gid=AXze4y91jTBkyUOJq6nwyD1&oh=00_AYBezPBeen24d6wuIFLpKHo90SMxVGM9g86YG5Z0qQvKwg&oe=67205E62"]
        const masonryWrapper = document.querySelector('.masonry')
        let componentStr = ""
        Array.from(feeds).filter((el) => {
          return !ignoreSrcs.includes(el.firstElementChild?.getAttribute('data-instafeed-src'))
        }).forEach((el, idx) => {
          componentStr += feedIt(el, title, idx + 1, captions[idx].textContent)
        })
        masonryWrapper.innerHTML = componentStr

        const appsWrapper = document.querySelector('.shopify-section--apps')
        console.log('appsWrapper', appsWrapper)
        appsWrapper.classList.add('sr-only')
        clearInterval(poll)
      }
    }, 500)
  });
})();

// force hide video player play button icon
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const videoPlayBtns = document.querySelectorAll('.play-button');
    videoPlayBtns.forEach(btn => btn.style.display = "none")
  })
})();